import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useContext, useForm,
} from "react";
import Input from "../common/inputfunction";
import { getCustomerList, searchcustomer } from "../../services/wms";
import Renderprofile from "./../management/renderprofilehub";
import BranchContext from "../context/branch";
import Input1 from "./../common/inputfunction";

const SearchProfilehub = ({ updateData, search = "", list }) => {
  const [data, setData] = useState({
search: search,
  });

  const { currentBranch } = useContext(BranchContext);
  const [master, setMaster] = useState([]);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [id, setId] = useState(0);
  const [custName, setcustName] = useState('');


  useEffect(() => {
    // const [data, setData] = useState({
    //   search: search,
    // });
  }, [custName]);


  useEffect(() => {
    if (custName !== "") {
      setData({ search: custName });
    }
  }, [custName]);

  useEffect(() => {
    setMaster([]);
  }, [currentBranch, data.custName, pageSize]);

  useEffect(() => {
    if (list && list.length > 0 && data.custName === "") {
      setMaster(list);
    }
  }, [list, data.custName]);

  async function api(searchname) {
    try {
      if (!searchname) {
        return;
      }
      const { data: result } = await searchcustomer(
        currentBranch && currentBranch._id,
        searchname
      );

      if (result.status === "success") {
      
        setMaster(result.data.list)
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);

      }


    } catch (error) {}
  }
   //console.log("setMaster",master)
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  function handleChange({ currentTarget: input }) {
    const { name, value } = input;
  
    setData((previous) => {
      return {
        previous,
        [name]: value,
      };
    });
  }
  const handleclick = (event) => {
    api(custName)

  };
  const  handleonKeyPress= (event) => {
    if (event.key === "Enter") {
      api(custName)
    }
   
  };
  const handleChangCusname = (event) => {
    setcustName(event.currentTarget.value);
  };
  function handleOnselected({ currentTarget: input }) {

    const { name } = input;


    const result = master.filter((i) => i._id == name);

    const data = result[0];
    updateData(data);
  }

  // console.log(master)
  return (
    <>
 
      <div className="row">
        <div className="col-sm-8">        
          <Input1
                label="ชื่อลูกค้า"
                name="customer"
                value={custName}            
                placeholder="ค้นหาชื่อลูกค้า"
                onChange={handleChangCusname}
                onKeyPress={handleonKeyPress}
                onClick={handleclick}
                search="ค้นหา"
                />

        </div>
      </div>
      <p className="text-success">
        แสดงข้อมูล {master ? master.length : 0} / {total} รายการ
        </p>

      <Renderprofile
        list={master}
        loading={loading}
        error={error}
        lastBookElementRef={lastBookElementRef}
        handleOnselected={handleOnselected}
      />
   
    </>
  );
};

export default SearchProfilehub;
